import { createApp } from "vue";

import Hero from "~/vue/Hero.vue";

// Main app
const hero = async () => {
	const app = createApp(Hero);

	app.use(window.pinia);

	return app.mount("#hero");
};

// Execute async function
hero().then(() => {
	console.log();
});
